import {
  OrderDeliveryInfo,
} from '@/models';
import { ApiService } from '../api/api.service';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { MUTATIONS as ORDER_MUTATIONS } from '@/store/order';
import { OrderService } from '../order/order.service';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { Logger } from '../logger';
import { AnalyticsService } from '../analytics/analytics.service';

export interface DeliveryService {
  getDeliveryInfo(deliveryId: string): Promise<OrderDeliveryInfo>;
  getMinimumOrderValueForDelivery(): number;
}

export class AppDeliveryService extends ApiService implements DeliveryService {

  constructor(store: Store<AppState>, httpClient: AxiosInstance, logger: Logger, private orderService: OrderService, protected analytics: AnalyticsService) {
    super(store, httpClient, logger, analytics);
  }
  
  getDeliveryInfo(deliveryId: string): Promise<OrderDeliveryInfo> {
    return this.httpClient
      .get(`delivery/v2/whitelabel/delivery/${deliveryId}`)
      .then((r: AxiosResponse<OrderDeliveryInfo>) => {
        this.store.commit(ORDER_MUTATIONS.SET_ORDER_DELIVERY_INFO, r.data);
        return r.data;
      })
      .catch(e => this.logAndThrowApiError('getDeliveryInfo', e));
  }

  getMinimumOrderValueForDelivery(): number {
    return this.orderService.getCurrentOrder()?.order.delivery?.minimumOrderValue ?? 0;
  }
}
